import { render, staticRenderFns } from "./RegisteredRecipients.vue?vue&type=template&id=76039eda&scoped=true&"
import script from "./RegisteredRecipients.vue?vue&type=script&lang=js&"
export * from "./RegisteredRecipients.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredRecipients.vue?vue&type=style&index=0&id=76039eda&prod&lang=scss&"
import style1 from "./RegisteredRecipients.vue?vue&type=style&index=1&id=76039eda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76039eda",
  null
  
)

export default component.exports